import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import Checkbox from "@material-ui/core/Checkbox";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  status: {
    color: theme.palette.info.main,
  },
  invoice: {
    color: theme.palette.error.main,
  },
  container: {
    maxHeight: 600,
    "& .MuiTableCell-stickyHeader": {
      backgroundColor: "#ffff",
    },
  },

  arrowIcon: {
    width: "30px",
    height: "30px",
  },
}));

function Row({ course, setToAddCourses, toAddCourses }) {
  const classes = useRowStyles();
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      setToAddCourses([...toAddCourses, event.target.value]);
    } else {
      setToAddCourses(
        toAddCourses.filter((item) => item !== event.target.value)
      );
    }
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <Checkbox
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            value={course?.courseId}
            onChange={handleChange}
            checked={checked}
          />
        </TableCell>
        <TableCell>{course?.courseTitle}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const AddCourseList = ({ course, setToAddCourses, toAddCourses }) => {
  const classes = useRowStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, course?.length - page * rowsPerPage);

  return (
    <>
      <TableContainer className={classes.container} component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Course</TableCell>
            </TableRow>
          </TableHead>
          {course?.length ? (
            <TableBody>
              {course
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  return (
                    <Row
                      key={index}
                      course={item}
                      setToAddCourses={setToAddCourses}
                      toAddCourses={toAddCourses}
                    />
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell>
                  <p>No Course</p>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={course?.length ?? 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};
